export default "__VITE_ASSET__Bnh3yJJd__"